import React from 'react';
import { Link } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';

const HomePage = () => {
  return (
    <MainLayout>
      <div className="page home-page">
        <h1>Civic Intelligence Platform</h1>
        <p>Collect public input, support community consultations, and build civic understanding.</p>
        <div className="home-actions">
          <Link to="/login" className="btn">Login</Link>
          <Link to="/register" className="btn btn-outline">Register</Link>
        </div>
      </div>
    </MainLayout>
  );
};

export default HomePage;
